const config = {
  name: "zen-greenville",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: false, // Display "Redemptions left" on promo code card
    mandatoryFields: true,
    userPhoneNumber: true,
    showAdaSupport: false,
    userName: false,
    userPostalCode: false
  },
  parkingSession: {
    // Until 23:59 2 days before
    cancelDaysBefore: 2,
    cancelTime: "23:59",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 8am
    startOffsetHrs: 8,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 30
  }
}
export default config
